<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="center"><img alt="image" src="images/p4.jpg"/></p>
<h2 class="recipe-ttile"><a id="page5"><span class="col6">contents</span></a></h2><a id="page5">
</a><p class="toc"><a id="page5"></a><a href="#/cap01#page7">introduction</a></p>
<p class="toc"><a href="#/cap02#page13"><span class="col3">drop cookies</span></a></p>
<p class="toc"><span href="#/cap03#page25" title="Link target outside of Sample"><span class="col2a">shaped cookies</span></span></p>
<p class="toc"><span href="#/cap04#page45" title="Link target outside of Sample"><span class="col4a">piped cookies</span></span></p>
<p class="toc"><span href="#/cap05#page55" title="Link target outside of Sample"><span class="col6a">rolled &amp; cut cookies</span></span></p>
<p class="toc"><span href="#/cap06#page71" title="Link target outside of Sample"><span class="col8">brownies &amp; bars</span></span></p>
<p class="toc"><span href="#/cap07#page87" title="Link target outside of Sample"><span class="col4">fillings &amp; coatings</span></span></p>
<p class="toc"><span href="#/cap08#page93" title="Link target outside of Sample">shipping baked goods</span></p>
<p class="toc"><span href="#/cap09#page94" title="Link target outside of Sample">index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?c32d0870